const ar = {
  task: {
    center: "مركز المهام",
    callTask: "مهمة الاتصال",
    giftTask: "مهمة هدية",
    liveTask: "مهمة الوافد الجديد",
    sevenTask: "مهمة لمدة 7 أيام",
    callMessage: "اتصل أكثر لتحصل على مكافآت",
    giftMessage: "تلقي الهدايا للحصول على المكافآت",
    liveMessage: "قم بزيادة مدة Live {d} لتحصل على مكافأة قدرها",
    sevenMessage: "{d} أكمل المهام اليومية لتحصل على مكافأة قدرها",
    cellTitle: "اتصال ≥{d} دقيقة) مرات):",
    reward: "مكافأة",
    lastWeek: "مكافأة الأسبوع الماضي:",
    weekGift: "عائدات الهدايا الأسبوعية:",
    RewardDescription: "تعليمات المكافأة",
    everyWeekGift: "عائدات الهدايا الأسبوعية <span class='web'>(Bonus)</span>",
    endTask: 'انتهت المهمة',
    query: 'موافق'
  },
  message: {
    taxt1: "1. تبدأ كل دورة تسوية من الاثنين إلى الأحد. كلما زادت مدة مكالمة الفيديو ≥{d} دقيقة ، زادت قيمة المكافآت",
    taxt2: "2. يمكنك الحصول على مكافآت بمستوى واحد فقط في الأسبوع ، بناءً على تقييم أوقات مدة مكالمتك الفردية هذا الأسبوع ≥{d}دقيقة",
    taxt3: "3. بعد التحقق الرسمي ، سيتم إصدار المكافآت إلى حسابك من قبل الخميس القادم بعد التسوية",
    taxt4: "4. إذا تم العثور على غش ، سيتم استبعادك من أي مكافأة",
    taxt5: "5. إذا كانت لديك أي أسئلة ، يرجى الرجوع إلى<span class='web'>support@honeycamweb.com</span>",
    hint: "ملاحظة: تخضع للتوقيت الدولي",
    rewardOne1: "1.في غضون 7 أيام بعد بدء المهمة",
    rewardOne2: "1) <span class='web'>Live≥؛</span> يوميًا لمدة 6 أيام على الأقل <span class='web'>{d}≤</span>ساعتان ومعدل إتمام المكالمة ",
    rewardOne3: "2) {d}≤ في غضون 7 أيام بعد بدء المهمة ، يصل إجمالي الدخل إلى Bonus",
    rewardOne4: "3) من النظام الأساسي بعد انتهاء المهمة ؛ <span style='color: #ff2794'>{d}</span> إذا تم استيفاء الشروط المذكورة أعلاه في نفس الوقت ، يمكنك الحصول على مكافأة قدرها",
    rewardOne5: "2.يمكن أن يكافئ المرساة حسابًا واحدًا على الأكثر ، والحسابات المتعددة غير صالحة ؛",
    rewardOne6: "3.إذا تم العثور على الغش ، فسيتم إلغاء التأهيل للحصول على المكافآت ؛",
    rewardOne7: "4.المستخدم الذي أكمل المهمة ، بعد انتهاء المهمة. تابع الصفحة الرئيسية الرسمية على <span class='web' style='color: #f99634'>\"Facebook \"Honeycam</span>، ؛ <span style='color: #ff2794'>$10</span> وأضف مجموعة لتحصل على مكافأة قدرها",
    rewardOne8: "5.إذا كانت لديك أي أسئلة ، يرجى الرجوع إلى<span class='web'>support@honeycamweb.com;</span>",
    rewardTwo1: "في اليوم أثناء المهمة الفرصة لدخول الموضع الأعلى للصفحات الموصى بها أو الشائعة في اليوم التالي لاكتساب المزيد من الظهور ؛{d}ستتاح للمستخدمين الذين يكسبون أكثر من"
  },
  gift: {
    test1: "1. دورة التسوية من الاثنين إلى الأحد. كلما حصلت على هدايا أكثر ، زادت سخاء المكافآت.",
    test2: "2. يمكنك الحصول على مكافآت لمستوى واحد فقط كل أسبوع ، ويتم تقييم المستوى بناءً على إجمالي الإيرادات لهذا الأسبوع.",
    test3: "3. بعد التحقق الرسمي ، سيتم إصدار المكافأة لحساب الإيرادات الخاص بك قبل يوم الخميس القادم.",
    test4: "4. إذا تم العثور على غش ، فسيتم استبعادك من أي مكافأة",
    test5: "5. إذا كانت لديك أي أسئلة ، يرجى الرجوع إلى<span class='web'>support@honeycamweb.com</span>",
    giftNum: "1≤ الهدايا المستلمة",
    totalBonus: "{d}≤ الدخل Bonus",
    liveCallTime: "<span class='web'>live</span>≥{d}(m)",
    callTime: "(m){d}≤ مكالمة",
    callRate: "接通率≥{d}%"
  },
  new: {
    rewardOne: "مكافأة واحدة",
    rewardTwo: "مكافأة اثنين",
    start: "افتتحت المهمة رسميًا في الساعة 0:00 اليوم",
    hint: "حافظ على Live≥{d} في اليوم ≤{d} ساعات ومعدل إتمام المكالمة. <span class='web'>{d}</span> يمكنك الحصول على مكافأة قدرها.",
    tastReward: "إجمالي الإيرادات <span class='web'>Bonus</span> خلال المهمة",
    liveTime: "مدة Live اليوم",
    callRate: "معدل إتمام المكالمة لليوم",
    progress: "تقدم المهمة",
    endRate: "(الهدف≥",
    overText1: "مبروك على الانتهاء من المهمة",
    overText2: "تابعوا موقع <span class='web'>\"Facebook \"Honeycam</span> {d} الرسمي وأضف مجموعة لتحصل على مكافأة قدرها",
    overText3: "{d} من المؤسف أن المهمة لم تكتمل ولا يمكنك الحصول على مكافأة قدرها",
    overText4: ".تابع <span class='web'>\"Facebook \"Honeycam</span> الرسمي للحصول على مزيد من المعلومات حول المهمة.",
    openfb: "افتح <span class='web'>Facebook</span>",
  },
  week: {
    live30: "غدًا Live≥{d} دقيقة",
    call5: "مكالمة غدًا  ≥5 دقيقة",
    rewardHint: "(<span style='color: #ff2794'><span class='web'>$20</span>فستحصل على مكافأة إضافية قدرها</span> ، إذا تم إكمال جميع المهام التالية)",
    newLive: "اليوم Live",
    newLiveSec: "({d}≤ الهدف)",
    newCall: "مكالمة اليوم",
    newCallRate: "معدل إتمام المكالمة لليوم",
    newBonus: "دخل اليوم Bonus",
    newGift: "عدد الهدايا اليوم",
    newReward: "مكافآت اليوم",
    days: "يوم",
    taskReq: "متطلبات المهمة",
    task1: "1.تتم تسوية المهام اليومية في الساعة 0:00 ، ويتم إصدارها لحساب Bonus الخاص بك في الساعة 0:00 ؛",
    task2: "2.إذا لم تكتمل المهمة في ذلك اليوم ، فسوف تفشل. لا يمكن استئناف المهمة الفاشلة ؛",
    task3: "3.؛ {d} تم إكمال جميع المهام التي تستغرق 7 أيام فقط ، ويمكن الحصول على حزمة مكافأة قدرها",
    task4: "4.يمكن أن يكافئ المرساة حسابًا واحدًا على الأكثر ، والحسابات المتعددة غير صالحة ؛",
    task5: "5.إذا تم العثور على غش ، فسيتم إلغاء الأهلية للحصول على المكافآت ؛",
    task6: "6.المستخدم الذي أكمل المهمة ، بعد انتهاء المهمة. تابع الصفحة الرئيسية الرسمية على <span class='web' style='color: #f99634'>\"Facebook \"Honeycam</span> ، ؛ <span style='color: #ff2794' class='web'>$20</span> وأضف مجموعة لتحصل على مكافأة قدرها",
    task7: "7.إذا كانت لديك أي أسئلة ، يرجى الرجوع إلى<span class='web'>support@honeycamweb.com;</span>",
  }
};

export default ar;

